import PropTypes from 'prop-types'
import React from 'react'
import Base from './BaseContainer'
import { connect } from 'react-redux'

import Loader from '../components/Loader/Loader'
import Constants from '../services/constants/Constants'

import globalStyles from '../styles/styles.module.scss'

class LoaderContainer extends Base {

  constructor() {
    super()
    this.state = {
      showCrouton: false,
    }
  }

  render() {
    const mustDisplay =
      this.props.httpStatus === Constants.ActionsConstants.HTTP.LOADING ||
      this.props.httpStatus === Constants.ActionsConstants.HTTP.UPLOADING ||
      this.props.force
    let loaderClassList = mustDisplay
      ? globalStyles.loaderContainer
      : globalStyles.loaderContainerEmpty
    return (
      <div className={loaderClassList}>
        {mustDisplay ? <Loader /> : null}
      </div>
    )
  }

}

LoaderContainer.propTypes = {
  force: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  httpStatus: PropTypes.string.isRequired,
}

const mapStateToProps = ({ http: { httpStatus } }) => ({
  httpStatus,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch: dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(LoaderContainer)
